import Vue from 'vue';

/**
 * Get default state for betslip messages
 */
const getDefaultState = () => ({
  /**
   * List of all available freebets for player
   * @type {import('bto-models/betslip/interfaces').FreebetItem[]}
   */
  freebets: [],
});

export const freebetStore = Vue.observable(getDefaultState());